import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { setting } from '../../../../../setting';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';

@Component({
  selector: 'usb-base-results-categories',
  templateUrl: './base-results-categories.component.html',
  styleUrls: ['./base-results-categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class BaseResultsCategoriesComponent implements OnInit {

// En tu componente base (modals.component.ts)
// @Input() categoryId: number = 0;
// @Input() tab: string = '';
// @Input() quote: boolean = true;
// @Input() buttonColorActive: string = '#e93a5b';
// @Input() buttonTextActive: string = '#ffffff';
// @Input() action: string = '';
// @Input() productSelect: boolean = false;

// // Datos del producto
// @Input() product: any;
// @Input() hotel: any;  // Para hoteles
// @Input() rentaCar: any;  // Para rent a car
// @Input() tour: any;  // Para tours
// @Input() insurance: any;  // Para seguros
// @Input() service: any;  // Para transportes
// @Input() ptheme: any;  // Para PThemes
// @Input() packages: any;  // Para paquetes

// // Configuración general
// @Input() currencyAgency: any;
// @Input() currencies: any[];
// @Input() clientSetting: any;
// @Input() form: any;
// @Input() payload: any;
// @Input() payloadUpdate: any;
// @Input() itineraryItem: any;
// @Input() arrayResults: any[];
// @Input() view_info: any;

// // Fechas y cantidades
// @Input() arrivalDate: string;
// @Input() departureDate: string;
// @Input() productQty: number = 1;

// // Para transportes
// @Input() vehicles: any[];
// @Input() formTransport: any;
// @Input() fliyingInfo: any;

// // Para Disney y otros
// @Input() _item: any;

// // Estado
// @Input() tabActive: string = 'rooms';
// @Input() paymentAgencyActive: any;

// // Calculados
// @Input() totalQty: number = 0;
// @Input() currencySelected: string = '';
clientSystemSetting: any;
// Outputs
@Output() refModal = new EventEmitter<any>();
@Output() tabChange = new EventEmitter<string>();
@Output() mapClick = new EventEmitter<void>();

  constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<BaseResultsCategoriesComponent>,
        private userService: UserService
  ) { }

  ngOnInit(): void {
    this.clientSystemSetting = JSON.parse(localStorage.getItem(setting.name));
    console.log(this.data)
  }

   // ============================================
  // GETTERS - Todo lo necesario desde data
  // ============================================

  get tab(): string {
    return this.data?.tabActive || this.data?.tab || 'rooms';
  }

  set tab(value: string) {
    if (this.data) this.data.tab = value;
  }

  get buttonColorActive(): string {
    return this.data?.buttonColorActive || '#e93a5b';
  }

  get buttonTextActive(): string {
    return this.data?.buttonTextActive || '#ffffff';
  }

  get action(): string {
    return this.data?.action || '';
  }

  get productSelect(): boolean {
    return this.data?.productSelect || false;
  }

  // Datos del producto (unificado)
  get product(): any {
    return this.data?.product || this.data?.hotel || this.data?.rentaCar ||
           this.data?.tour || this.data?.insurance || this.data?.service || null;
  }

  get hotel(): any {
    return this.data?.hotel || this.data?.product;
  }

  get rentaCar(): any {
    return this.data?.rentaCar || this.data?.product;
  }

  get tour(): any {
    return this.data?.tour || this.data?.product;
  }

  get insurance(): any {
    return this.data?.insurance || this.data?.product;
  }

  get service(): any {
    return this.data?.service || this.data?.product;
  }

  // Configuración general
  get currencyAgency(): any {
    return this.userService.currency;
  }

  get currencies(): any[] {
    return this.userService.currenciesExchange || [];
  }

  get clientSetting(): any {
    return this.clientSystemSetting;
  }

  get form(): any {
    return this.data?.form;
  }

  get payload(): any {
    return this.data?.payload;
  }

  get payloadUpdate(): any {
    return this.data?.payloadUpdate;
  }

  get itineraryItem(): any {
    return this.data?.itineraryItem;
  }

  get arrayResults(): any[] {
    return this.data?.arrayResults || [];
  }

  get view_info(): any {
    return this.data?.view_info;
  }

  // Fechas y cantidades
  get arrivalDate(): string {
    return this.data?.arrivalDate;
  }

  get departureDate(): string {
    return this.data?.departureDate;
  }

  get productQty(): number {
    return this.data?.productQty || 1;
  }

  // Para transportes
  get vehicles(): any[] {
    return this.data?.vehicles || [];
  }

  get formTransport(): any {
    return this.data?.formTransport;
  }

  get fliyingInfo(): any {
    return this.data?.fliyingInfo;
  }

  // Para Disney
  get _item(): any {
    return this.data?._item;
  }

  // Estado
  get tabActive(): string {
    return this.data?.tabActive || 'rooms';
  }

  get paymentAgencyActive(): any {
    return this.data?.paymentAgencyActive;
  }

  // Calculados
  get totalQty(): number {
    return this.data?.totalQty || 0;
  }

  get currencySelected(): string {
    return this.data?.currencySelected || this.currencyAgency?.code || 'USD';
  }

  get disableButton(): boolean {
    return this.data?.disableButton || false;
  }

  // Hoteles específicos
  get starArray(): number[] {
    return [1, 2, 3, 4, 5];
  }

  get categoryId(): number {
    return this.data?.categoryId;
  }

  get quote(): boolean {
    return this.data?.quote;
  }

  get rate(): number {
    const starRating = this.hotel?.additionalInfo?.starRating;
    if (!starRating) return 0;
    const match = starRating.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  // ============================================
  // MÉTODOS
  // ============================================

  close(): void {
    this.refModal.emit('close');
    this.dialogRef?.close();
  }

  hideModal(event: any): void {
    this.refModal.emit(event);
  }

  mapMarker(): void {
    // Lógica para mostrar mapa
  }

  continue(): void {
    // Lógica para continuar
  }

  getAddress(location: string, isFirstLine: boolean): string {
    if (!location) return '';
    const parts = location.split(',');
    if (isFirstLine) {
      return parts[0]?.trim() || '';
    }
    return parts.slice(1).join(',').trim() || '';
  }

  stingUpperCase(str: string): string {
    return str?.toUpperCase() || '';
  }

}
